// import TweenLite from './vendor/TweenLite';
// import { qs, qsArray } from './utilities/selectors';
import { qs, qsArray, isInternetExplorer, isEdge, trackEvent } from "./utilities/index"
import Application from "./application"
import Overlay from "./overlay"

let Question = function (params) {
	// console.log('Question initalizing ' + params);

	/**
	 *
	 */
	let self = this
	let elementId = params.elementId
	let QuestionElement = document.getElementById(params.elementId)
	// 'multiple-choice' or 'range-slider'
	let type = QuestionElement.getAttribute("data-question-type")
	let background = QuestionElement.querySelector(".bg-image")
	let text = QuestionElement.querySelector(".question-wrap")
	let importantButton = QuestionElement.querySelector(".btn-important")
	let contentImage = QuestionElement.querySelector(".content-image")
	let controls = QuestionElement.querySelector(".controls")
	let answers = qsArray(".answer", QuestionElement)
	let slider = QuestionElement.querySelector(".slider")
	let dropdown = QuestionElement.querySelector(".question-dropdowns select")
	let nextButton = QuestionElement.querySelector(".next-button")
	let timeline
	let selectedAnswerId = ""
	let selectedDirection = 0
	let sliderTween1 = null
	let sliderTween2 = null
	let sliderTween3 = null
	let overlay = new Overlay()
	let question5Scores = [200, 191, 181, 171, 161, 151, 141, 131, 121, 111, 100]
	// console.log('answers is ' + answers);
	// console.log('slider is ' + slider);
	// console.log('question type is ' + type);

	this.open = function () {
		// console.log('Question.open');
		window.resizeFrame();
		window.ironSelector.fillProgressBar()
		TweenLite.set([background, text, contentImage, controls], { opacity: 0 })
		TweenLite.set(answers, { opacity: 0 })
		if (slider !== null) {
			TweenLite.set(slider, { opacity: 0 })
		}
		QuestionElement.style.display = "block"
		timeline = new TimelineLite({ onComplete: this.openComplete, onCompleteScope: this })
		timeline.to(background, Application.tweenLength, { opacity: 1 })
		timeline.to(text, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		if (contentImage !== null) {
			timeline.to(contentImage, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		}
		for (let x = 0; x < answers.length; x++) {
			timeline.to(answers[x], Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		}
		if (slider !== null) {
			timeline.to(slider, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		}
		timeline.to(controls, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		timeline.play()
	}

	this.openComplete = function () {
		if (type === "multiple-choice") {
			this.initialzeImportantButton()
			this.initializeAnswers()
			//this.initializePreviousButton()
			// this.initializeNextButton();
			if (selectedAnswerId !== "") {
				this.initializeNextButton()
			}
		} else if (type === "range-slider") {
			this.initialzeImportantButton()
			this.initializeSlider()
			//this.initializePreviousButton()
			this.initializeNextButton()
		} else if (type === "dropdown") {
			this.initialzeImportantButton()
			this.initializeDropDown()
		} else if (type === "iron-set") {
			this.initialzeImportantButton()
			this.initializeIronSet()
		} else if (type === "priority") {
			this.initialzeImportantButton()
			this.initializePriorities()
		}
		
	}

	this.initializeAnswers = function () {
		// console.log('init answers ' + this.answerClicked);
		let answer
		for (let x = 0; x < answers.length; x++) {
			answer = answers[x]
			answer.addEventListener("click", this.answerClicked)
		}
		// console.log('question has ' + answers.length + ' answers');
	}

	this.disableAnswers = function () {
		let answer
		for (let x = 0; x < answers.length; x++) {
			answer = answers[x]
			answer.removeEventListener("click", this.answerClicked)
		}
	}

	this.initializeSlider = function () {
		if (slider !== null) {
			this.input = slider.querySelector("input")
			this.value = slider.querySelector(".value")
			
			if (isInternetExplorer() === true) {
				// chrome slider released, works in ie
				this.input.addEventListener("change", this.sliderChanged)
			} else {
				// chrome slider moved, doesn't work in ie works in edge and everything else
				this.input.addEventListener("input", this.sliderChanged)
			}

			if (elementId !== "question-2") {
				this.sliderImage1 = QuestionElement.querySelector(".slider-image-1")
				this.sliderImage2 = QuestionElement.querySelector(".slider-image-2")
				this.sliderImage3 = QuestionElement.querySelector(".slider-image-3")
			}

			self.sliderChanged();
			self.initializeNextButton();

			let tooltip = slider.querySelector(".tooltip");

			if (tooltip) {
				let isDragging = false;
				let startX;
				let initialLeft;

				function handleMove(deltaX) {
					let newLeft = initialLeft + deltaX;

					// Get container and draggable dimensions
					const containerRect = tooltip.parentElement.getBoundingClientRect();
					const draggableRect = tooltip.getBoundingClientRect();

					// Calculate the maximum allowed left position
					//const maxLeft = containerRect.width - draggableRect.width;
					//console.log('containerRect.width=' + containerRect.width + ' draggableRect.width=' + draggableRect.width)
					const maxLeft = containerRect.width;
					// Constrain the newLeft within the container's bounds
					console.log('newLeft=' + newLeft + ' maxLeft=' + maxLeft)
					newLeft = Math.max(0, Math.min(newLeft, maxLeft));

					tooltip.style.left = `${newLeft}px`;

					let tempVal = (newLeft / maxLeft) * 100;
					console.log('tempVal=' + tempVal)
					let newVal = (Math.round(tempVal / 5) * 5) + 100;
					console.log('newVal=' + newVal)
					self.input.value = newVal;
					self.sliderUpdateDisplay();
				}

				tooltip.addEventListener('mousedown', (e) => {
					isDragging = true;
					tooltip.classList.add('dragging');
					startX = e.clientX; // Get the initial mouse X position
					initialLeft = tooltip.offsetLeft; // Get the initial left position of the draggable element
				});

				document.addEventListener('mousemove', (e) => {
					if (!isDragging) return;

					// Calculate the new horizontal position based on mouse movement
					const deltaX = e.clientX - startX;
					handleMove(deltaX);
				});

				document.addEventListener('mouseup', () => {
					isDragging = false;
					tooltip.classList.remove('dragging');
				});

				// Handle touch events for mobile devices
				tooltip.addEventListener('touchstart', (e) => {
					isDragging = true;
					tooltip.classList.add('dragging');
					startX = e.touches[0].clientX;
					initialLeft = tooltip.offsetLeft;
				});

				document.addEventListener('touchmove', (e) => {
					if (!isDragging) return;
					const deltaX = e.touches[0].clientX - startX;
					handleMove(deltaX);
				});

				document.addEventListener('touchend', () => {
					isDragging = false;
					tooltip.classList.remove('dragging');
				});
			}
		}
	}

	this.sliderUpdateDisplay = function () {

		var rangeAmount = self.input.max - self.input.min;
		var ratio = ((self.input.value - self.input.min) / rangeAmount);
		var percentage = ratio * 100;
		var tooltip = QuestionElement.querySelector('.tooltip');
		if (tooltip) {
			let containerWid = tooltip.parentElement.clientWidth;
			let tooltipPos = containerWid * ratio;
			
			//if (ratio < 0.5) {
			//	tooltipPos += 8 - (8 * ratio);
			//} else if (ratio > 0.5) {
			//	tooltipPos -= 8 * ratio;;
			//}
			
			QuestionElement.querySelector('.tooltip').innerHTML = self.input.value;
			QuestionElement.querySelector('.tooltip').style.left = tooltipPos + 'px';
		}

		var fill = QuestionElement.querySelector('.track .fill');
		if (fill) {
			fill.style.width = percentage + '%';
		}

		//slider.style.setProperty('--range-value', percentage + '%');

		if (QuestionElement.querySelectorAll('.number-label').length > 0) {
			QuestionElement.querySelectorAll('.number-label').forEach((elem) => elem.classList.remove('active'));
			if (percentage >= 100) {
				QuestionElement.querySelectorAll('.node-2,.node-3,.node-4,.node-5').forEach((elem) => elem.classList.add('active'));
				if (percentage == 100) {
					QuestionElement.querySelector('.number-label-5').classList.add('active');
				}
			}
			else if (percentage >= 75) {
				QuestionElement.querySelectorAll('.node-2,.node-3,.node-4').forEach((elem) => elem.classList.add('active'));
				QuestionElement.querySelectorAll('.node-5').forEach((elem) => elem.classList.remove('active'));
				if (percentage == 75) {
					QuestionElement.querySelector('.number-label-4').classList.add('active');
				}
			} else if (percentage >= 50) {
				QuestionElement.querySelectorAll('.node-2,.node-3').forEach((elem) => elem.classList.add('active'));
				QuestionElement.querySelectorAll('.node-4,.node-5').forEach((elem) => elem.classList.remove('active'));
				if (percentage == 50) {
					QuestionElement.querySelector('.number-label-3').classList.add('active');
				}
			} else if (percentage >= 25) {
				QuestionElement.querySelectorAll('.node-2').forEach((elem) => elem.classList.add('active'));
				QuestionElement.querySelectorAll('.node-3,.node-4,.node-5').forEach((elem) => elem.classList.remove('active'));
				if (percentage == 25) {
					QuestionElement.querySelector('.number-label-2').classList.add('active');
				}
			} else {
				QuestionElement.querySelectorAll('.node-2,.node-3,.node-4,.node-5').forEach((elem) => elem.classList.remove('active'));
				if (percentage == 0) {
					QuestionElement.querySelector('.number-label-1').classList.add('active');
				}
			}
		}

		
		if (QuestionElement.querySelectorAll('.meter-line').length > 0) {
			
			QuestionElement.querySelectorAll('.meter-line ').forEach((elem) => elem.classList.remove('active'));
			QuestionElement.querySelectorAll('.meter-line')[self.input.value].classList.add('active');
		}


	}

	this.sliderChanged = function () {
		console.log("changed: " + elementId)
		self.sliderUpdateDisplay();

		//swap images for other sliders
		let index = self.input.value
		let tweenLength = 0.1
		let delayLength = 0
		if (sliderTween1 !== null) {
			sliderTween1.kill()
			sliderTween2.kill()
			sliderTween3.kill()
			sliderTween1 = null
			sliderTween2 = null
			sliderTween3 = null
		}
			// question 4 is full fade to black
		if (elementId === "question-6" || elementId === "question-10" || elementId === "question-11") {

			// question 5 and 6 is crossfade
			// console.log('show slider image ' + index);
			if (index < 4) {
				sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 1 })
				sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 0 })
				sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 0 })
			} else if (index >= 4 && index <= 6) {
				sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 0 })
				sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 1 })
				sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 0 })
			} else if (index > 6) {
				sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 0 })
				sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 0 })
				sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 1 })
			}

		}
	}


	this.initializeIronSet = function () {
		QuestionElement.querySelector('#q4a1');
		var singleModelBtn = QuestionElement.querySelector('#q4a1');
		singleModelBtn.addEventListener("click", this.enableSingleModelIronSet)

		var blendedSetBtn = QuestionElement.querySelector('#q4a2');
		blendedSetBtn.addEventListener("click", this.enableBlendedIronSet)

		let resetSingleBtn = QuestionElement.querySelector('#btn-reset-single');
		resetSingleBtn.addEventListener("click", this.resetSingleIronSet)

		let resetBlendedBtn = QuestionElement.querySelector('#btn-reset-blended');
		resetBlendedBtn.addEventListener("click", this.resetBlendedIronSet)

		let blendedSetContainer = QuestionElement.querySelector('.model-set-form.blended-set');
		let singleModelSetContainer = QuestionElement.querySelector('.model-set-form.single-model');

		if (blendedSetContainer && blendedSetContainer.style.display == 'block') {
			self.enableBlendedIronSet();
		} else if (singleModelSetContainer && singleModelSetContainer.style.display == 'block') {
			self.enableSingleModelIronSet();
		}
	}

	this.enableSingleModelIronSet = function () {
		self.goToIronSetStep2();

		var singleModelSet = QuestionElement.querySelector('.model-set-form.single-model');
		singleModelSet.style.display = 'block';

		TweenLite.to(singleModelSet, Application.tweenLength, { opacity: 1 })
		self.setupModelSetField(singleModelSet);

		var brandDropdown = singleModelSet.querySelector('select');

		if (brandDropdown.selectedIndex > 0) {
			self.initializeNextButton();
		} else {
			self.disableControls();
		}

		brandDropdown.addEventListener('change', function (evt) {
			var drp = evt.target;
			if (drp.value != 'default') {
				self.initializeNextButton();
			}
		});


	}

	this.enableBlendedIronSet = function () {
		self.goToIronSetStep2();

		var blendedModelSet = QuestionElement.querySelector('.model-set-form.blended-set');
		blendedModelSet.style.display = 'block';

		TweenLite.to(blendedModelSet, Application.tweenLength, { opacity: 1 })

		var model1Set = QuestionElement.querySelector('.model-set-form.blended-set .model1');
		var model1Dropdown = QuestionElement.querySelector('.model-set-form.blended-set .model1 select');
		self.setupModelSetField(model1Set);

		var model2Set = QuestionElement.querySelector('.model-set-form.blended-set .model2');
		var model2Dropdown = QuestionElement.querySelector('.model-set-form.blended-set .model2 select');
		self.setupModelSetField(model2Set);

		if (model1Dropdown.value != 'default' && model2Dropdown.value != 'default') {
			self.initializeNextButton();
		} else {
			self.disableControls();
		}

		QuestionElement.querySelectorAll('.model-set-form.blended-set select').forEach(brandDropdown => {
			brandDropdown.addEventListener('change', function (evt) {
				if (model1Dropdown.value != 'default' && model2Dropdown.value != 'default') {
					self.initializeNextButton();
				}
			});
		});

	}

	this.resetSingleIronSet = function () {
		let singleModelSet = QuestionElement.querySelector('.model-set-form.single-model');
		singleModelSet.style.display = 'none';

		let brandDropdown = singleModelSet.querySelector('select');
		brandDropdown.selectedIndex = 0;

		singleModelSet.querySelector('.double-slider').noUiSlider.reset();

		self.goToIronSetStep1();
		self.disableControls();
	}

	this.resetBlendedIronSet = function () {
		let blendedModelSet = QuestionElement.querySelector('.model-set-form.blended-set');
		blendedModelSet.style.display = 'none';

		let model1Dropdown = QuestionElement.querySelector('.model-set-form.blended-set .model1 select');
		let model2Dropdown = QuestionElement.querySelector('.model-set-form.blended-set .model2 select');


		blendedModelSet.querySelector('.model1 .double-slider').noUiSlider.reset();
		blendedModelSet.querySelector('.model2 .double-slider').noUiSlider.reset();

		model1Dropdown.selectedIndex = 0;
		model2Dropdown.selectedIndex = 0;

		self.goToIronSetStep1();
		self.disableControls();
	}


	this.goToIronSetStep1 = function () {
		QuestionElement.querySelector('.answers').style.display = 'block';
		QuestionElement.querySelector('.question-detail-text').style.display = 'block';
	}

	this.goToIronSetStep2 = function () {
		QuestionElement.querySelector('.answers').style.display = 'none';
		QuestionElement.querySelector('.question-detail-text').style.display = 'none';
	}


	this.setupModelSetField = function (modelSet) {


		modelSet.querySelector('.selector-wrap').classList.add('is-active', 'is-visible');

		//var slider1 = modelSet.querySelector('.set-bottom');
		//var slider2 = modelSet.querySelector('.set-top');



		var dblSlider = modelSet.querySelector('.double-slider');

		if (!dblSlider.noUiSlider) {

			noUiSlider.create(dblSlider, {
				start: [0, 100],
				connect: true,
				step: 1,
				range: {
					'min': 0,
					'max': 8
				}
			});


			var vals = dblSlider.noUiSlider.get();
			this.updateSetDescription(modelSet, parseInt(vals[0]), parseInt(vals[1]));

			dblSlider.noUiSlider.on('update.one', function () {
				let vals = dblSlider.noUiSlider.get();
				console.log(JSON.stringify(vals));

				var lowerLimit = parseInt(vals[0]);
				var upperLimit = parseInt(vals[1]);
				self.updateSetDescription(modelSet, lowerLimit, upperLimit);



				for (var y = 0; y <= 8; y++) {
					if (y < lowerLimit || y > upperLimit) {
						modelSet.querySelectorAll('.club-number')[y].classList.add('inactive');
					} else {
						modelSet.querySelectorAll('.club-number')[y].classList.remove('inactive');
					}
				}
			});
		}
		
		var buttonIndex = 0;
		modelSet.querySelectorAll('.club-number').forEach((btn) => {
			btn.addEventListener("click", (e) => {
				let sliderElem = modelSet.querySelector('.double-slider');
				let vals = sliderElem.noUiSlider.get();
				var lowerLimit = parseInt(vals[0]);
				var upperLimit = parseInt(vals[1]);

				var newVal = parseInt(btn.getAttribute('data-index'));

				if (Math.abs(newVal - lowerLimit) < Math.abs(upperLimit - newVal)) {
					lowerLimit = newVal;
				} else {
					upperLimit = newVal;
				}

				sliderElem.noUiSlider.set([lowerLimit, upperLimit]); 

				//currentSlider.setSliderValue(e, newVal, false);
				//this.updateSetDescription(modelSet, currentSlider);
			});
			buttonIndex++;
		});
	}

	this.updateSetDescription = function (modelSet, lowerLimit, upperLimit) {
		var setDescription = modelSet.querySelector('.set-description');

		var clubNumbers = modelSet.querySelectorAll('.club-number');

		setDescription.innerHTML = clubNumbers[lowerLimit].innerHTML + '-' + clubNumbers[upperLimit].innerHTML;
	}

	this.initializeDropDown = function () {
		if (dropdown == null) {
			return;
		}

		if (dropdown.value != 'default') {
			selectedAnswerId = dropdown.value;
			self.initializeNextButton();
		}

		dropdown.parentNode.classList.add('is-active');
		dropdown.parentNode.classList.add('is-visible');

		dropdown.addEventListener('change', function () {
			// console.log(dropdownA.value);
			let value = dropdown.value;
			if (value != 'default') {
				selectedAnswerId = value;
				self.initializeNextButton();
			} else {
				self.disableControls();
			}
		});
	}



	this.initializePriorities = function () {
		var allRadios = QuestionElement.querySelectorAll('input[type="radio"]');
		allRadios.forEach(function (elem) {
			elem.addEventListener("change", function (evt) {
				var currentVal = evt.target.value;
				var currentId = evt.target.id;
				allRadios.forEach(function (radio) {
					if (radio.checked && currentVal == radio.value && radio.id != currentId) {
						radio.checked = false;
					}
				});

				if (self.prioritiesCompleted()) {
					self.initializeNextButton();
				} else {
					self.disableControls();
				}			
			});	
		});

		if (self.prioritiesCompleted()) {
			self.initializeNextButton();
		} else {
			self.disableControls();
		}

	}

	this.prioritiesCompleted = function () {
		var clubDesign = QuestionElement.querySelector('input[name="clubdesign"]:checked');
		var trajectory = QuestionElement.querySelector('input[name="trajectory"]:checked');
		var performance = QuestionElement.querySelector('input[name="performance"]:checked');


		return (clubDesign && trajectory && performance);
	}

	this.initialzeImportantButton = function () {
		if (importantButton !== null) {
			// console.log('enable important button');
			importantButton.addEventListener("click", this.importantButtonClicked)
		}
	}

	this.initializePreviousButton = function () {
		// console.log('init previous button ' + previousButton);
		previousButton.addEventListener("click", this.previousClicked)
	}

	this.initializeNextButton = function () {
		// console.log('init next button ' + nextButton);
		nextButton.addEventListener("click", this.nextClicked)
		nextButton.classList.remove("disabled")
		// nextButton.classList.add('enabled');
	}

	this.disableControls = function () {
		
		nextButton.classList.add("disabled")
		nextButton.removeEventListener("click", this.nextClicked)
	}

	this.answerClicked = function (event) {
		// console.log('Question.answerClicked ' + event.target.id);
		// console.log('selected answer id was ' + self.selectedAnswerId);
		if (selectedAnswerId === "") {
			self.initializeNextButton()
		}
		self.resetAnswers()
		// if its multiple choice set values here, if its slider set it in nextClicked
		selectedAnswerId = event.target.id
		event.target.classList.add("selected")
		// console.log('now selected answer id is ' + self.selectedAnswerId);
	}

	this.resetAnswers = function () {
		let answer
		for (let x = 0; x < answers.length; x++) {
			answer = answers[x]
			answer.classList.remove("selected")
		}
		selectedAnswerId = ""
	}

	this.importantButtonClicked = function () {
		overlay.openImportantWindow(elementId)
	}

	this.previousClicked = function (event) {
		// console.log('Question.previousClicked ' + event.target.id);
		self.selectedDirection = -1
		self.close();
		
		// window.ironSelector.questionClosed(-1);
		trackEvent("navigation", "Previous")
	}

	this.nextClicked = function (event) {
		// console.log('Question.previousClicked ' + event.target.id);
		self.selectedDirection = 1
		let currentScore = -1;
		let answerText = '';

		answerText = selectedAnswerId;
		if (elementId == 'question-1') {
			if (selectedAnswerId == 'q1a2') {
				document.querySelectorAll('.question').forEach((elem) => elem.classList.add('women'));
			} else {
				document.querySelectorAll('.question').forEach((elem) => elem.classList.remove('women'));
			}
		}

		if (elementId == 'question-3') {
			answerText = dropdown.options[dropdown.selectedIndex].value;
			currentScore = dropdown.selectedIndex;
		}

		if (elementId == 'question-5') {
			let distance = self.input.value;
			answerText = distance;
			for (let y = 0; y < question5Scores.length; y++) {
				if (question5Scores[y] <= distance) {
					currentScore = y;
					break;
				}
			}
		}

		//inverse range value
		if (elementId == 'question-6' || elementId == 'question-8' || elementId == 'question-11') {
			currentScore = 10 - self.input.value;
			answerText = currentScore;
		}

		if (elementId == 'question-7' || elementId == 'question-10') {
			currentScore = self.input.value;
			answerText = self.input.value;
		}

		if (elementId == 'question-9') {
			let button = document.getElementById(selectedAnswerId);
			if (button != null) {
				currentScore = button.getAttribute("data-score");
			}

		}

		if (elementId == 'question-12') {
			let clubDesign = QuestionElement.querySelector('input[name="clubdesign"]:checked');
			let trajectory = QuestionElement.querySelector('input[name="trajectory"]:checked');
			let performance = QuestionElement.querySelector('input[name="performance"]:checked');

			trackEvent("answer", 'question-12-clubDesign', clubDesign.value)
			trackEvent("answer", 'question-12-trajectory', trajectory.value)
			trackEvent("answer", 'question-12-performance', performance.value)
		}

		if (currentScore >= 0) {
			window.ironSelector.applyScore(elementId, currentScore);
		}

		// store answer in the main application history
		//if (elementId != 'question-3' && elementId != 'question-4' && elementId != 'question-5') {
		//	window.ironSelector.storeAnswer(selectedAnswerId);
		//}
		// close it up
		self.close()
		trackEvent("answer", elementId, answerText)
		trackEvent("navigation", "Next")
	}

	this.close = function () {
		// console.log('close ' + selectedAnswerId);
		this.disableAnswers()
		this.disableControls()
		window.ironSelector.fillProgressBar()
		timeline.kill()
		timeline = new TimelineLite({ onComplete: closeComplete, onCompleteScope: this })
		timeline.to(controls, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		for (let x = answers.length - 1; x >= 0; x--) {
			timeline.to(answers[x], Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		}
		if (slider !== null) {
			timeline.to(slider, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		}
		timeline.to(contentImage, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		timeline.to(text, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		timeline.to(background, Application.tweenLength, { opacity: 0 })
		timeline.timeScale(2)
		timeline.play()
	}

	function closeComplete() {
		// console.log('closeComplete ' + this.selectedDirection);
		timeline.kill()
		timeline = null
		// content.style.display = 'none';
		QuestionElement.style.display = "none"
		window.ironSelector.questionClosed(this.selectedDirection)
	}

}

export default Question
